import React from "react";
import { Box, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";

export default function ErrorMessage({
  height = "50vh",
  message = "Hubo un problema desconocido",
  fontSize = 80,
}) {
  return (
    <div>
      <Box
        sx={{
          height,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Info color="disabled" sx={{ fontSize }} />
        </Box>
        <Box sx={{ my: 1 }} />
        <Typography color="gray" align="center" variant="h6">
          {message}
        </Typography>
      </Box>
    </div>
  );
}
